export const PRIMARY_BLUE = "#03aeec";
export const DARK_BLUE = "#004e98";
export const CRIMSON_RED = "#c1121f";
export const BG_COLOR = "#1E1E1E";
export const PINK = "pink";
export const HOT_PINK = "hotpink";
// UNKNOWN pet gender, same values as the mobile app's ThemeColors.UNKNOWN_*
export const UNKNOWN_GENDER_LIGHT_MODE = "#1F2937";
export const UNKNOWN_GENDER_DARK_MODE = "#e7e7e7";
export const SUCCESS_PRIMARY_MUI = "#2e7d32";
